import React from 'react';

import { Text } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { BokehTooltip } from '@vimeo/live-core/components/bokeh';

import { createInteractionDomName } from '../../../../libs/shared/utils/dom/identifying';

interface IChatMessageAuthorProps extends IBaseDomElementProps {
  isCurrentSender: boolean;
  senderName: string;
}

export function ChatMessageAuthor({
  className = createInteractionDomName('question-author-name'),
  senderName,
}: IChatMessageAuthorProps) {
  return (
    <BokehTooltip placement={'bottom'} label={senderName} shouldWrapChildren={false}>
      <Text
        className={className}
        variant={'heading-xs'}
        textOverflow={'ellipsis'}
        whiteSpace={'nowrap'}
        overflow={'hidden'}
        maxWidth={'100%'}
      >
        {senderName}
      </Text>
    </BokehTooltip>
  );
}
